import APIClient from '@/shared/http/clients/api'

const resourceName = 'movimentacao'
const APICore = process.env.APIBaseURLCore

const GetAll = (data = {}, filter, limit, index, config = {}) => APIClient.get(`${APICore}/${resourceName}/associados/?paId=${data}&nomeAssociado=${filter}&hasNotGR=true&page=${index}&size=${limit}`, data, config)

const MovimentationRepository = {
  GetAll
}

export default MovimentationRepository



// WEBPACK FOOTER //
// ./src/shared/http/repositories/configurations/movimentation.js